/* eslint-disable @typescript-eslint/no-explicit-any */
let cid = 1;

declare global {
  interface HTMLScriptElement {
    onreadystatechange: any;
    readyState: string;
  }
}


function buildParams(params: Record<any, any>) {
  const result = [];

  // eslint-disable-next-line no-restricted-syntax
  for (const i in params) {
    result.push(`${encodeURIComponent(i)}=${encodeURIComponent(params[i])}`);
  }

  return result.join('&');
}

const jsonpAdapter = function (config: Record<any, any>): Promise<any> {
  return new Promise(((resolve, reject) => {
    let script: HTMLScriptElement | null = document.createElement('script');
    let src = config.url;

    if (config.params) {
      const params = buildParams(config.params);

      if (params) {
        src += (src.indexOf('?') >= 0 ? '&' : '?') + params;
      }
    }

    script.async = true;

    function remove() {
      if (script) {
        script.onload = null;
        script.onreadystatechange = null;
        script.onerror = null;

        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }

        script = null;
      }
    }

    // eslint-disable-next-line no-plusplus
    const jsonp = `axiosJsonpCallback${cid++}`;
    const old = window[jsonp];
    let isAbort = false;

    window[jsonp] = function (responseData: Record<any, any>) {
      window[jsonp] = old;

      if (isAbort) {
        return;
      }

      const response = {
        data: responseData,
        status: 200,
        statusText: 'OK',
        config,
        request: {
          responseURL: script?.src,
        },
        headers: {},
      };

      resolve(response);
    };

    const additionalParams: Record<any, any> = {
      _: (new Date().getTime()),
    };

    additionalParams[config.callbackParamName || 'callback'] = jsonp;

    src += (src.indexOf('?') >= 0 ? '&' : '?') + buildParams(additionalParams);

    // eslint-disable-next-line no-multi-assign
    script.onload = script.onreadystatechange = function () {
      if (!script?.readyState || /loaded|complete/.test(script?.readyState)) {
        remove();
      }
    };

    script.onerror = function () {
      remove();

      reject(new Error('Network Error'));
    };

    if (config.cancelToken) {
      config.cancelToken.promise.then((cancel: any) => {
        if (!script) {
          return;
        }

        isAbort = true;

        reject(cancel);
      });
    }

    script.src = src;

    document.head.appendChild(script);
  }));
};

export default jsonpAdapter;
